import React, { createContext, useState, useEffect, useContext } from 'react';
import { AuthContext } from './AuthContext'; // Assicurati che il percorso sia corretto

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { user: authUser } = useContext(AuthContext); // Recupera l'utente autenticato dall'AuthContext
  const [user, setUser] = useState({
    name: authUser ? authUser.name : 'John Doe',
    discount: authUser ? authUser.discount : 0.55 // Usa lo sconto dell'utente autenticato
  });

  useEffect(() => {
    if (authUser) {
      setUser({
        name: authUser.name,
        discount: authUser.discount || 0 // Imposta lo sconto dell'utente autenticato, oppure 0 se non disponibile
      });
    }
  }, [authUser]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
